/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import { RootState } from '../../../../setup'
// import {Languages} from './Languages'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import { useDispatch } from 'react-redux'
import { toAbsoluteUrl } from '../../../helpers'
import profileAPI from '../../../../api/profile/profileAPI'
import { toast } from 'react-toastify'

const HeaderUserMenu: FC = () => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const [role, setRole] = useState<number>(0)
  const dispatch = useDispatch()
  const logout = () => {
    dispatch(auth.actions.logout())
  }

  const userData: any = useSelector<RootState>(
    ({ auth }) => auth?.user,
    shallowEqual,

  )
  //console.log(userData.data.role.id);
  const [isLogged, setIsLogged] = useState<boolean | null>(null)
  useEffect(() => {
    if (userData) {
      console.log(userData)
      setRole(userData?.data?.role?.role_id)
    }
  }, [userData])

  // useEffect(() => {
  //   profileAPI.userInfo().then(
  //     (res: any) => {
  //       console.log(res, 'res')
  //       setIsLogged(true)
  //       console.log('login success')
  //     },
  //     (err: any) => {
  //       if (err?.response?.data?.success === false) {
  //         toast.error(err.response.data.message, {
  //           theme: 'dark',
  //         })
  //       }

  //       if (err?.response?.data?.message === 'Unauthorize Request') {
  //         setIsLogged(false)
  //         // dispatch logout
  //         dispatch(auth.actions.logout())
  //       }
  //     },
  //   )
  // }, [isLogged])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
    

     

      <div className='menu-item px-5 mb-1'>

        <Link to='user/information' className='menu-link px-5'>
              User Profile
        </Link>

        <Link to='user/change-password' className='menu-link px-5'>
              Change Password
        </Link>

        <Link to='#' onClick={logout} className='menu-link px-5'>
             Log Out
        </Link>

      </div>

      
    </div>
  )
}

export { HeaderUserMenu }
